import { defineComponent as i, ref as b, nextTick as d, h as f } from "vue";
import o from "./ghl-ui.es197.js";
const l = i({
  __TAB_PANE__: !0,
  props: {
    name: {
      type: [String, Number]
    },
    tab: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, { slots: a, expose: r }) {
    const n = b(null);
    return r({
      syncBarPosition: () => {
        d(() => {
          var t;
          return (t = n.value) == null ? void 0 : t.syncBarPosition();
        });
      }
    }), () => f(
      o,
      {
        ref: n,
        name: e.name,
        tab: e.tab,
        disabled: e.disabled
      },
      () => a == null ? void 0 : a.default()
    );
  }
});
export {
  l as default
};
